import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import connect from 'components/lib/connect';
import InsetContainer from 'components/common/containers/inset_container';
import InlineContainer from 'components/common/containers/inline_container';
import NavigateTo from 'actions/current_location/navigate_to';
import NavigateToUser from 'actions/users/navigate_to_user';
import OpenModal from 'actions/modal/open_modal';
import SearchInput from 'components/common/search_input';
import { SecondaryButton } from 'components/common/button';
import UploadCsv from 'models/modal/upload_csv';
import UserEditor from 'models/location/user_editor';
import UsersTable from './users_table';
import UploadCSVIcon from 'scripts/presentation/components/lib/icons/upload_csv_icon';

export class UsersSection extends React.Component {
  constructor(props) {
    super(props);
    _.bindAll(this, ['handleChangeTextFilter', 'handleClearTextFilter', 'handleUserSelection']);

    this.state = { textFilter: props.textFilter };
  }

  handleChangeTextFilter(evt) {
    this.setState({ textFilter: evt.target.value });
  }

  handleClearTextFilter() {
    this.setState({ textFilter: '' });
  }

  render() {
    return (
      <Users>
        <SearchButtonsContainer inset="large">
          <SearchInputContainer>
            <SearchInput
              autoFocus
              initialValue={this.state.textFilter}
              onChange={this.handleChangeTextFilter}
              onClearText={this.handleClearTextFilter}
              placeholder="Search for an agent"
            />
          </SearchInputContainer>
          {this.renderUserButtons()}
        </SearchButtonsContainer>
        <UsersTable textFilter={this.state.textFilter} onUserSelectClick={this.handleUserSelection} />
      </Users>
    );
  }

  renderUserButtons() {
    if (!this.props.canEditUsers) {
      return null;
    }

    return (
      <ButtonsWrapper>
        <UsersActionButton data-aid="addUserButton" onClick={this.props.onClickNew}>
          Add User
        </UsersActionButton>
        <UsersActionButton data-aid="uploadCsvButton" onClick={this.props.onClickUploadCsv}>
          <UploadIcon />
          Upload CSV
        </UsersActionButton>
      </ButtonsWrapper>
    );
  }

  handleUserSelection({ userId, paginationStartIndex }) {
    this.props.canEditUsers &&
      this.props.onUserSelectClick({ paginationStartIndex, textFilter: this.state.textFilter, userId });
  }
}

UsersSection.propTypes = {
  canEditUsers: PropTypes.bool,
  textFilter: PropTypes.string,
  onClickNew: PropTypes.func.isRequired,
  onClickUploadCsv: PropTypes.func.isRequired,
  onUserSelectClick: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapExecuteToProps)(UsersSection);

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  return {
    canEditUsers: isFeatureEnabled('userManagement'),
    textFilter: getProvider('currentLocation').get().textFilter,
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onClickNew: () => executeAction(NavigateTo, UserEditor.create()),
    onClickUploadCsv: () => executeAction(OpenModal, UploadCsv.create()),
    onUserSelectClick: ({ paginationStartIndex, textFilter, userId }) =>
      executeAction(NavigateToUser, { paginationStartIndex, textFilter, userId }),
  };
}

const Users = styled.div`
  margin-top: 56px; /* account for header next door */
  flex-grow: 1;
  overflow-y: auto;
`;

const SearchButtonsContainer = styled(InsetContainer)`
  flex-direction: row;
  flex-shrink: 0;
  align-items: center;
`;

const SearchInputContainer = styled.div`
  flex-basis: 55%;
`;

const ButtonsWrapper = styled(InlineContainer).attrs({ inset: 'none' })`
  flex-basis: 45%;
  flex-direction: row;
  justify-content: flex-end;
`;

const UsersActionButton = styled(SecondaryButton)`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 120px;
`;

const UploadIcon = styled(UploadCSVIcon)`
  height: 13px;
  width: 13px;
  flex-shrink: 0;
  line-height: 0;
  stroke: ${p => p.theme.colors.green400};
  margin-right: ${p => p.theme.spacing.small};
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/users_section.jsx